/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalTerms } from './AdditionalTerms';
import {
    AdditionalTermsFromJSON,
    AdditionalTermsFromJSONTyped,
    AdditionalTermsToJSON,
} from './AdditionalTerms';
import type { AppraisalContingency } from './AppraisalContingency';
import {
    AppraisalContingencyFromJSON,
    AppraisalContingencyFromJSONTyped,
    AppraisalContingencyToJSON,
} from './AppraisalContingency';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentCommission } from './BuyerAgentCommission';
import {
    BuyerAgentCommissionFromJSON,
    BuyerAgentCommissionFromJSONTyped,
    BuyerAgentCommissionToJSON,
} from './BuyerAgentCommission';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage } from './BuyerAgentCommissionPercentage';
import {
    BuyerAgentCommissionPercentageFromJSON,
    BuyerAgentCommissionPercentageFromJSONTyped,
    BuyerAgentCommissionPercentageToJSON,
} from './BuyerAgentCommissionPercentage';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ClientProposedTermsRequestHomeWarrantyPaidBy } from './ClientProposedTermsRequestHomeWarrantyPaidBy';
import {
    ClientProposedTermsRequestHomeWarrantyPaidByFromJSON,
    ClientProposedTermsRequestHomeWarrantyPaidByFromJSONTyped,
    ClientProposedTermsRequestHomeWarrantyPaidByToJSON,
} from './ClientProposedTermsRequestHomeWarrantyPaidBy';
import type { ClosingDate } from './ClosingDate';
import {
    ClosingDateFromJSON,
    ClosingDateFromJSONTyped,
    ClosingDateToJSON,
} from './ClosingDate';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage } from './ConcessionsPercentage';
import {
    ConcessionsPercentageFromJSON,
    ConcessionsPercentageFromJSONTyped,
    ConcessionsPercentageToJSON,
} from './ConcessionsPercentage';
import type { DdPeriodDays } from './DdPeriodDays';
import {
    DdPeriodDaysFromJSON,
    DdPeriodDaysFromJSONTyped,
    DdPeriodDaysToJSON,
} from './DdPeriodDays';
import type { DownPayment } from './DownPayment';
import {
    DownPaymentFromJSON,
    DownPaymentFromJSONTyped,
    DownPaymentToJSON,
} from './DownPayment';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { EarnestMoneyDeposit } from './EarnestMoneyDeposit';
import {
    EarnestMoneyDepositFromJSON,
    EarnestMoneyDepositFromJSONTyped,
    EarnestMoneyDepositToJSON,
} from './EarnestMoneyDeposit';
import type { EscalationCapCents } from './EscalationCapCents';
import {
    EscalationCapCentsFromJSON,
    EscalationCapCentsFromJSONTyped,
    EscalationCapCentsToJSON,
} from './EscalationCapCents';
import type { EscalationEnabled } from './EscalationEnabled';
import {
    EscalationEnabledFromJSON,
    EscalationEnabledFromJSONTyped,
    EscalationEnabledToJSON,
} from './EscalationEnabled';
import type { EscalationIncrementCents } from './EscalationIncrementCents';
import {
    EscalationIncrementCentsFromJSON,
    EscalationIncrementCentsFromJSONTyped,
    EscalationIncrementCentsToJSON,
} from './EscalationIncrementCents';
import type { FinancingContingency } from './FinancingContingency';
import {
    FinancingContingencyFromJSON,
    FinancingContingencyFromJSONTyped,
    FinancingContingencyToJSON,
} from './FinancingContingency';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingType } from './FinancingType';
import {
    FinancingTypeFromJSON,
    FinancingTypeFromJSONTyped,
    FinancingTypeToJSON,
} from './FinancingType';
import type { HomeWarranty } from './HomeWarranty';
import {
    HomeWarrantyFromJSON,
    HomeWarrantyFromJSONTyped,
    HomeWarrantyToJSON,
} from './HomeWarranty';
import type { HomeWarrantyAmountCents } from './HomeWarrantyAmountCents';
import {
    HomeWarrantyAmountCentsFromJSON,
    HomeWarrantyAmountCentsFromJSONTyped,
    HomeWarrantyAmountCentsToJSON,
} from './HomeWarrantyAmountCents';
import type { InspectionContingency } from './InspectionContingency';
import {
    InspectionContingencyFromJSON,
    InspectionContingencyFromJSONTyped,
    InspectionContingencyToJSON,
} from './InspectionContingency';
import type { InspectionPeriodDays } from './InspectionPeriodDays';
import {
    InspectionPeriodDaysFromJSON,
    InspectionPeriodDaysFromJSONTyped,
    InspectionPeriodDaysToJSON,
} from './InspectionPeriodDays';
import type { OfferPrice } from './OfferPrice';
import {
    OfferPriceFromJSON,
    OfferPriceFromJSONTyped,
    OfferPriceToJSON,
} from './OfferPrice';
import type { SellerConcessions } from './SellerConcessions';
import {
    SellerConcessionsFromJSON,
    SellerConcessionsFromJSONTyped,
    SellerConcessionsToJSON,
} from './SellerConcessions';
import type { TitleCompany } from './TitleCompany';
import {
    TitleCompanyFromJSON,
    TitleCompanyFromJSONTyped,
    TitleCompanyToJSON,
} from './TitleCompany';

/**
 * Body for the public buyer counter (`POST /api/v1/public/transactions/{id}/counter`).
 * 
 * Mirrors ``CounterTransactionRequest`` on the term fields — so the same
 * ``create_counter_terms`` diff/carry-forward applies — and deliberately withholds
 * the three that are not a consumer's to set. The route spreads this body straight
 * into the service, so each omission is the whole of its enforcement:
 * 
 * * ``source``: hard-wired to BUYER in the route, so a consumer can never spoof a
 *   seller-side counter.
 * * ``document_ids``: only a seller-sourced counter mails paperwork; ids here would
 *   be validated and then dropped.
 * * ``send_email``: the email a buyer counter dispatches is the inbound notice
 *   telling ops the counter arrived, which the buyer does not get to suppress.
 * @export
 * @interface PublicCounterTransactionRequest
 */
export interface PublicCounterTransactionRequest {
    /**
     * 
     * @type {OfferPrice}
     * @memberof PublicCounterTransactionRequest
     */
    offerPrice?: OfferPrice;
    /**
     * 
     * @type {FinancingType}
     * @memberof PublicCounterTransactionRequest
     */
    financingType?: FinancingType;
    /**
     * 
     * @type {EarnestMoneyDeposit}
     * @memberof PublicCounterTransactionRequest
     */
    earnestMoneyDeposit?: EarnestMoneyDeposit;
    /**
     * 
     * @type {ClosingDate}
     * @memberof PublicCounterTransactionRequest
     */
    closingDate?: ClosingDate;
    /**
     * 
     * @type {TitleCompany}
     * @memberof PublicCounterTransactionRequest
     */
    titleCompany?: TitleCompany;
    /**
     * 
     * @type {SellerConcessions}
     * @memberof PublicCounterTransactionRequest
     */
    sellerConcessions?: SellerConcessions;
    /**
     * 
     * @type {BuyerAgentCommission}
     * @memberof PublicCounterTransactionRequest
     */
    buyerAgentCommission?: BuyerAgentCommission;
    /**
     * 
     * @type {DdPeriodDays}
     * @memberof PublicCounterTransactionRequest
     */
    ddPeriodDays?: DdPeriodDays;
    /**
     * 
     * @type {AppraisalContingency}
     * @memberof PublicCounterTransactionRequest
     */
    appraisalContingency?: AppraisalContingency;
    /**
     * 
     * @type {FinancingContingency}
     * @memberof PublicCounterTransactionRequest
     */
    financingContingency?: FinancingContingency;
    /**
     * 
     * @type {InspectionContingency}
     * @memberof PublicCounterTransactionRequest
     */
    inspectionContingency?: InspectionContingency;
    /**
     * 
     * @type {AdditionalTerms}
     * @memberof PublicCounterTransactionRequest
     */
    additionalTerms?: AdditionalTerms;
    /**
     * 
     * @type {DownPayment}
     * @memberof PublicCounterTransactionRequest
     */
    downPayment?: DownPayment;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof PublicCounterTransactionRequest
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof PublicCounterTransactionRequest
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof PublicCounterTransactionRequest
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {InspectionPeriodDays}
     * @memberof PublicCounterTransactionRequest
     */
    inspectionPeriodDays?: InspectionPeriodDays;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof PublicCounterTransactionRequest
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage}
     * @memberof PublicCounterTransactionRequest
     */
    concessionsPercentage?: ConcessionsPercentage;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof PublicCounterTransactionRequest
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage}
     * @memberof PublicCounterTransactionRequest
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof PublicCounterTransactionRequest
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {EscalationEnabled}
     * @memberof PublicCounterTransactionRequest
     */
    escalationEnabled?: EscalationEnabled;
    /**
     * 
     * @type {EscalationIncrementCents}
     * @memberof PublicCounterTransactionRequest
     */
    escalationIncrementCents?: EscalationIncrementCents;
    /**
     * 
     * @type {EscalationCapCents}
     * @memberof PublicCounterTransactionRequest
     */
    escalationCapCents?: EscalationCapCents;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof PublicCounterTransactionRequest
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {HomeWarranty}
     * @memberof PublicCounterTransactionRequest
     */
    homeWarranty?: HomeWarranty;
    /**
     * 
     * @type {ClientProposedTermsRequestHomeWarrantyPaidBy}
     * @memberof PublicCounterTransactionRequest
     */
    homeWarrantyPaidBy?: ClientProposedTermsRequestHomeWarrantyPaidBy;
    /**
     * 
     * @type {HomeWarrantyAmountCents}
     * @memberof PublicCounterTransactionRequest
     */
    homeWarrantyAmountCents?: HomeWarrantyAmountCents;
}

/**
 * Check if a given object implements the PublicCounterTransactionRequest interface.
 */
export function instanceOfPublicCounterTransactionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicCounterTransactionRequestFromJSON(json: any): PublicCounterTransactionRequest {
    return PublicCounterTransactionRequestFromJSONTyped(json, false);
}

export function PublicCounterTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicCounterTransactionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerPrice': !exists(json, 'offer_price') ? undefined : OfferPriceFromJSON(json['offer_price']),
        'financingType': !exists(json, 'financing_type') ? undefined : FinancingTypeFromJSON(json['financing_type']),
        'earnestMoneyDeposit': !exists(json, 'earnest_money_deposit') ? undefined : EarnestMoneyDepositFromJSON(json['earnest_money_deposit']),
        'closingDate': !exists(json, 'closing_date') ? undefined : ClosingDateFromJSON(json['closing_date']),
        'titleCompany': !exists(json, 'title_company') ? undefined : TitleCompanyFromJSON(json['title_company']),
        'sellerConcessions': !exists(json, 'seller_concessions') ? undefined : SellerConcessionsFromJSON(json['seller_concessions']),
        'buyerAgentCommission': !exists(json, 'buyer_agent_commission') ? undefined : BuyerAgentCommissionFromJSON(json['buyer_agent_commission']),
        'ddPeriodDays': !exists(json, 'dd_period_days') ? undefined : DdPeriodDaysFromJSON(json['dd_period_days']),
        'appraisalContingency': !exists(json, 'appraisal_contingency') ? undefined : AppraisalContingencyFromJSON(json['appraisal_contingency']),
        'financingContingency': !exists(json, 'financing_contingency') ? undefined : FinancingContingencyFromJSON(json['financing_contingency']),
        'inspectionContingency': !exists(json, 'inspection_contingency') ? undefined : InspectionContingencyFromJSON(json['inspection_contingency']),
        'additionalTerms': !exists(json, 'additional_terms') ? undefined : AdditionalTermsFromJSON(json['additional_terms']),
        'downPayment': !exists(json, 'down_payment') ? undefined : DownPaymentFromJSON(json['down_payment']),
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'inspectionPeriodDays': !exists(json, 'inspection_period_days') ? undefined : InspectionPeriodDaysFromJSON(json['inspection_period_days']),
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentageFromJSON(json['concessions_percentage']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentageFromJSON(json['buyer_agent_commission_percentage']),
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'escalationEnabled': !exists(json, 'escalation_enabled') ? undefined : EscalationEnabledFromJSON(json['escalation_enabled']),
        'escalationIncrementCents': !exists(json, 'escalation_increment_cents') ? undefined : EscalationIncrementCentsFromJSON(json['escalation_increment_cents']),
        'escalationCapCents': !exists(json, 'escalation_cap_cents') ? undefined : EscalationCapCentsFromJSON(json['escalation_cap_cents']),
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'homeWarranty': !exists(json, 'home_warranty') ? undefined : HomeWarrantyFromJSON(json['home_warranty']),
        'homeWarrantyPaidBy': !exists(json, 'home_warranty_paid_by') ? undefined : ClientProposedTermsRequestHomeWarrantyPaidByFromJSON(json['home_warranty_paid_by']),
        'homeWarrantyAmountCents': !exists(json, 'home_warranty_amount_cents') ? undefined : HomeWarrantyAmountCentsFromJSON(json['home_warranty_amount_cents']),
    };
}

export function PublicCounterTransactionRequestToJSON(value?: PublicCounterTransactionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offer_price': OfferPriceToJSON(value.offerPrice),
        'financing_type': FinancingTypeToJSON(value.financingType),
        'earnest_money_deposit': EarnestMoneyDepositToJSON(value.earnestMoneyDeposit),
        'closing_date': ClosingDateToJSON(value.closingDate),
        'title_company': TitleCompanyToJSON(value.titleCompany),
        'seller_concessions': SellerConcessionsToJSON(value.sellerConcessions),
        'buyer_agent_commission': BuyerAgentCommissionToJSON(value.buyerAgentCommission),
        'dd_period_days': DdPeriodDaysToJSON(value.ddPeriodDays),
        'appraisal_contingency': AppraisalContingencyToJSON(value.appraisalContingency),
        'financing_contingency': FinancingContingencyToJSON(value.financingContingency),
        'inspection_contingency': InspectionContingencyToJSON(value.inspectionContingency),
        'additional_terms': AdditionalTermsToJSON(value.additionalTerms),
        'down_payment': DownPaymentToJSON(value.downPayment),
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'inspection_period_days': InspectionPeriodDaysToJSON(value.inspectionPeriodDays),
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentageToJSON(value.concessionsPercentage),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentageToJSON(value.buyerAgentCommissionPercentage),
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'escalation_enabled': EscalationEnabledToJSON(value.escalationEnabled),
        'escalation_increment_cents': EscalationIncrementCentsToJSON(value.escalationIncrementCents),
        'escalation_cap_cents': EscalationCapCentsToJSON(value.escalationCapCents),
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'home_warranty': HomeWarrantyToJSON(value.homeWarranty),
        'home_warranty_paid_by': ClientProposedTermsRequestHomeWarrantyPaidByToJSON(value.homeWarrantyPaidBy),
        'home_warranty_amount_cents': HomeWarrantyAmountCentsToJSON(value.homeWarrantyAmountCents),
    };
}

